import React from "react";
import "../css/bibliotecacra.css";

// Fotografías
import Cra01 from "../img/Cra01.jpeg";
import Cra02 from "../img/Cra02.jpeg";
import Cra03 from "../img/Cra03.jpeg";
import Cra04 from "../img/papelucho.jpeg";
import Cra05 from "../img/el caleuche.jpeg";
import Cra06 from "../img/la pincoya.jpeg";
import Cra07 from "../img/el copihue.jpeg";

const BibliotecaCraComponent = () => {

  const actividades = [

    {
      id:1,
      categoria:"Biblioteca CRA",
      titulo:"Actividad",
      imagen:Cra01,
    },

    {
      id:2,
      categoria:"Biblioteca CRA",
      titulo:"Actividad",
      imagen:Cra02,
    },

    {
      id:3,
      categoria:"Biblioteca CRA",
      titulo:"Actividad",
      imagen:Cra03,
    },

    {
      id:4,
      categoria:"Biblioteca CRA",
      titulo:"Papelucho",
      imagen:Cra04,
    },

    {
      id:5,
      categoria:"Biblioteca CRA",
      titulo:"El Caleuche",
      imagen:Cra05,
    },

    {
      id:6,
      categoria:"Biblioteca CRA",
      titulo:"La Pincoya",
      imagen:Cra06,
    },

    {
      id:7,
      categoria:"Biblioteca CRA",
      titulo:"El Copihue",
      imagen:Cra07,
    },

  ];

  const ampliarImagen = (imagen) => {

    window.open(imagen,"_blank");

  };

  return (

    <section
      id="biblioteca-cra-component"
      className="cra-container"
    >

      <div className="cra-header">

        <h2 className="cra-title">

          Biblioteca CRA

        </h2>

        <p className="cra-subtitle">

          Conozca algunas de las actividades realizadas por nuestros estudiantes.
          <br />
          <strong>Doble clic sobre una fotografía para ampliarla.</strong>

        </p>

      </div>

      <div className="cra-grid">

        {

          actividades.map((item)=>(

            <div
              key={item.id}
              className="cra-card"
            >

              <div className="cra-badge">

                {item.categoria}

              </div>

              <div className="cra-image-wrapper">

                <img

                  src={item.imagen}

                  alt={item.titulo}

                  className="cra-image"

                  onDoubleClick={()=>ampliarImagen(item.imagen)}

                />

              </div>

              <div className="cra-footer">

                {item.titulo}

              </div>

            </div>

          ))

        }

      </div>

    </section>

  );

};

export default BibliotecaCraComponent;